import { shuffle } from "lodash";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ContentCenter from "../../ui/ContentCenter";
import PlayButton from "../../ui/PlayButton";
import MemorizeScreen from "./MemorizeScreen";
import AnswerScreen from "./AnswerScreen";

const SecondText = styled.strong`
  font-size: 25px;
`;

const BetweenScreen = ({ level, setShowAnswer, setShowBetween }: any) => {
  const sekunden = level === 1 ? 10 : level === 2 ? 15 : 18;
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    setTimeout(() =>setOpacity(1),100);
  },[])

  const handleStartClick = () => {
    setOpacity(0);
    setTimeout(() => {
      setShowBetween(false);
      setShowAnswer(true);
    }, 1000);
  };

  return (
    <ContentCenter column style={{ width: "90%", textAlign: "center", opacity, transition: "opacity 1s" }}>
      <img src={`/remember/empty-${level === 4 ? 3 : level}.png`} />
      <p>
        Klicken Sie in der richtigen Reihenfolge auf die Symbole, die Sie eben
        gesehen haben. Sie haben dazu maximal{" "}
        <span>
          <SecondText>{sekunden}</SecondText>
        </span>{" "}
        Sekunden Zeit.
      </p>
      <PlayButton onClick={handleStartClick}>Abfrage starten</PlayButton>
    </ContentCenter>
  );
};

const createSymbols = (amountOfMemoSymbols: number, amountOfAnswerSymbols: number) => {
  let images: string[] = new Array(23);
  for (let i = 0; i < 23; i++) {
    images[i] = `/remember/${i + 1}.png`;
  }
  const shuffledImages = shuffle(images).slice(0,amountOfAnswerSymbols);
  const memorizeSymbols = shuffle(shuffledImages).slice(0,amountOfMemoSymbols)
  return {shuffledImages, sliced: memorizeSymbols};
};

export default ({
  level,
  disabled,
  setGameOver,
  gameOver,
  restart
}: {
  level: number;
  disabled: boolean;
  setGameOver: Dispatch<SetStateAction<boolean>>;
  gameOver: boolean;
  restart: number;
}) => {
  const amountOfMemoSymbols = level + 3;
  const amountOfAnswerSymbols = level === 1 ? 12: level === 2 ? 15 : 18;
  const [showBetween, setShowBetween] = useState(false);
  const [showMemo, setShowMemo] = useState(true);
  const [symbols, setSymbols]: any = useState([]);
  const [memorizeSymbols, setMemorizeSymbols]: any = useState(
    []
  );
  const [showAnswer, setShowAnswer] = useState(false);

  useEffect(() => {
    const symbolData = createSymbols(amountOfMemoSymbols, amountOfAnswerSymbols);
    setSymbols(symbolData.shuffledImages);
    setMemorizeSymbols(symbolData.sliced);
    setShowAnswer(false);
    setShowMemo(true);
    console.log(symbolData)
  },[restart])

  return (
    <ContentCenter style={{ height: "100%" }}>
      {showMemo && (
        <MemorizeScreen
          memorizeSymbols={memorizeSymbols}
          amountOfMemoSymbols={amountOfMemoSymbols}
          setShowMemo={setShowMemo}
          setShowBetween={setShowBetween}
        />
      )}
      {showBetween && (
        <BetweenScreen
          level={level}
          setShowAnswer={setShowAnswer}
          setShowBetween={setShowBetween}
        />
      )}
      {showAnswer && (
        <AnswerScreen
          level={level}
          symbols={symbols}
          memorizeSymbols={memorizeSymbols}
          amountOfMemoSymbols={amountOfMemoSymbols}
          setGameOver={setGameOver}
          gameOver={gameOver}
        />
      )}
    </ContentCenter>
  );
};
